export default "__VITE_ASSET__DCoPBORJ__"